function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 5.20768C0 2.41163 2.34081 0.14209 5.22635 0.14209H65.4896C68.3763 0.14209 70.716 2.41163 70.716 5.20768V65.7933C70.716 68.5902 68.3763 70.8581 65.4896 70.8581H5.22635C2.34109 70.8581 0 68.5905 0 65.7942V5.20685V5.20768Z",
  fill: "#006699"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4899 59.3218V27.4852H10.9079V59.3218H21.491H21.4899ZM16.2011 23.1392C19.8905 23.1392 22.1874 20.6945 22.1874 17.6394C22.1183 14.5146 19.8905 12.1382 16.2713 12.1382C12.6496 12.1382 10.2842 14.5146 10.2842 17.6391C10.2842 20.6943 12.5802 23.1389 16.1318 23.1389H16.2003L16.2011 23.1392ZM27.3472 59.3218H37.9283V41.5447C37.9283 40.5945 37.9974 39.6417 38.2769 38.963C39.0416 37.0612 40.7827 35.0924 43.7066 35.0924C47.5347 35.0924 49.0669 38.0117 49.0669 42.2919V59.3218H59.6478V41.0677C59.6478 31.2892 54.4281 26.7388 47.4662 26.7388C41.7583 26.7388 39.2515 29.9291 37.8587 32.1019H37.9292V27.4863H27.3477C27.4858 30.473 27.3469 59.3229 27.3469 59.3229L27.3472 59.3218Z",
  fill: "white"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab394907.svg";
export { ForwardRef as ReactComponent };